import React from 'react'
import { ItemContainer, Title } from '~/app/components/order-list/common/OrderDetailsCommonStyled'
import ItemView from '../../common/ItemView'

interface RatePlanInformationProps {
  id?: string
  ratePlanTitle?: string
  ratePlanBenefits?: string[]
  description?: string
}

const RatePlanInformation: React.FC<RatePlanInformationProps> = ({
  id,
  ratePlanTitle,
  ratePlanBenefits,
  description,
}) => {
  const hasBenefits = (ratePlanBenefits?.length || 0) > 0

  return (
    <ItemContainer id={id}>
      <Title>요금제 정보</Title>
      {ratePlanTitle && <ItemView title={'요금제명'} description={ratePlanTitle} />}
      {hasBenefits && (
        <ItemView title={'구성'}>
          <ul>
            {ratePlanBenefits?.map((benefit, idx) => (
              <li key={idx}>{benefit}</li>
            ))}
          </ul>
        </ItemView>
      )}
      {description && <ItemView title={'설명'} description={description} />}
    </ItemContainer>
  )
}

export default RatePlanInformation
